import React from 'react';

export const Footer = (props) => {
    return(
        <div className="footer">
            <p>
                Copyright 2018 <span><a href="https://github.com/VictorAtanasov">Victor Atanasov</a></span> | All Rights Reserved
            </p>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Footer.js